import {client} from './services/client'

export  const uploads = {
    namespaced:true,
    state:{
        uploads:[],
    },
    mutations: {
        SET_UPLOADS (state,uploads){
            state.uploads = uploads
        },

    },
    actions: {
        setUpload({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/uploads/save',
                    data:data,
                })
                    .then((response)=>{
                        let uploads = response.data.uploads;
                        commit('SET_UPLOADS',uploads);
                        console.log("uploads "+JSON.stringify(uploads));
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUploadCat({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/uploads/setUploadCat',
                    data:data,
                })
                    .then((response)=>{
                        let uploads = response.data.uploads;
                        commit('SET_UPLOADS',uploads);
                        console.log("uploads "+JSON.stringify(uploads));
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUploadTier({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/uploads/setUploadTier',
                    data:data,
                })
                    .then((response)=>{
                        let uploads = response.data.uploads;
                        commit('SET_UPLOADS',uploads);
                        console.log("uploads "+JSON.stringify(uploads));
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUploadPharma({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/uploads/setUploadPharma',
                    data:data,
                })
                    .then((response)=>{
                        let uploads = response.data.uploads;
                        commit('SET_UPLOADS',uploads);
                        console.log("uploads "+JSON.stringify(uploads));
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setAttribution({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/uploads/setAttribution',
                    data:data,
                })
                    .then((response)=>{
                        let uploads = response.data.uploads;
                        commit('SET_UPLOADS',uploads);
                        console.log("uploads "+JSON.stringify(uploads));
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        },
    getters: {
        getUploads: state  => {
            return state.uploads
        },
    }
};
